const common = {
  borderRadius: 'large',
  py: '0.75em',
  px: '1.25em',
};

export const cards = {
  primary: {
    ...common,
    bg: 'white',
    border: '1px solid',
    borderColor: 'border',
  },
};
